import { useState } from "react";
import { Box, Avatar, Typography, SvgIcon, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import MenuUserPopover from "./MenuUserPopover";
import { useAuth } from "../../auth/context";
import _ from "lodash";
import AvatarUser from "./AvatarUser";

export default function AccountUser() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { user } = useAuth();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Grid item xs={12} onClick={handleClick} sx={{ display: "flex", alignItems: "center", cursor: "pointer", pr: 2, pl: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <AvatarUser />
          <Typography sx={{ textAlign: "center", ml: 2, mr: 2, display: { xs: "none", sm: "none", md: "block" } }}>{`${user.name} ${user.surname}`}</Typography>
          {open ? (
            <SvgIcon sx={{ color: "#3887BE" }}>
              <ExpandLessIcon />
            </SvgIcon>
          ) : (
            <SvgIcon sx={{ color: "#3887BE" }}>
              <ExpandMoreIcon />
            </SvgIcon>
          )}
        </Box>
      </Grid>

      <MenuUserPopover open={open} anchorEl={anchorEl} handleClose={handleClose} />
    </>
  );
}
